/**
 * **NOTE** The utility component in this file are a direct copy of a function found in the preview component of:
 * `src/modules/templateEditor/EditWhatsApp/preview/`. This exists as a copy so that if something changes in the
 * templateEditor module, it won't break the utility here that is meant to be a temporary solution.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import { MessageContentHeader, MessageBodyMedia } from './ContentPreviewWhatsApp.styled';

import type { TemplateDiffContentWhatsApp } from '../../../types';

type PreviewWhatsAppHeaderProps = {
  header: TemplateDiffContentWhatsApp['header'];
};

export const PreviewWhatsAppHeader = ({ header }: PreviewWhatsAppHeaderProps) => {
  if (header && 'ImageHeader' in header) {
    return (
      <MessageBodyMedia
        data-test="table-diff-whats-app-preview-image"
        src={header.ImageHeader.mediaUrl}
      />
    );
  }

  if (header && 'TextHeader' in header) {
    return (
      <MessageContentHeader data-test="table-diff-whats-app-preview-text">
        {header.TextHeader.text}
      </MessageContentHeader>
    );
  }

  return null;
};
